const reducerUtils = {
    applyProps(state, properties) {
        return { ...state, ...properties };
    },
};

export default reducerUtils;
